const unauthorizedStatusCode = 403;

/**
 * Checks if the provided RTKQ error is an RBAC permission error. Any error
 * with a status code of 403 is considered an RBAC permission error.
 */
export const isRbacPermissionError = (error: unknown) => {
  if (!error) {
    return false;
  }

  return (
    (error as { originalStatus: number })?.originalStatus ===
      unauthorizedStatusCode ||
    (error as { status: string })?.status === `${unauthorizedStatusCode}` ||
    (error as { statusCode: string })?.statusCode ===
      `${unauthorizedStatusCode}`
  );
};
